// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .backgroundImage--hmUgN {
  background-image: url('/dist/src/img/backgrounds/grey_background.png');
  background-size: cover;
  padding-bottom: 70px;
}

.backgroundWhite--LZ9sd {
  &:empty {
    display: none;
  }
}

[dir] .backgroundWhite--LZ9sd {
  background-color: white;
  padding: 25px;
  margin-top: 15px;
  border-radius: 14px
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/SubjectDetailedInfo/styles.css"],"names":[],"mappings":"AAAA;EACE,sEAAsE;EACtE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EAKE;IACE,aAAa;EACf;AACF;;AARA;EACE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB;AAIF","sourcesContent":[".backgroundImage {\n  background-image: url('/dist/src/img/backgrounds/grey_background.png');\n  background-size: cover;\n  padding-bottom: 70px;\n}\n\n.backgroundWhite {\n  background-color: white;\n  padding: 25px;\n  margin-top: 15px;\n  border-radius: 14px;\n  &:empty {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundImage": `backgroundImage--hmUgN`,
	"backgroundWhite": `backgroundWhite--LZ9sd`
};
export default ___CSS_LOADER_EXPORT___;
